import { Component } from '@angular/core';
import { FooterComponent } from '../../../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../../../landing-page-v2/components/header/header.component';
import { FixedCallComponent } from '../../fixed-call/fixed-call.component';

@Component({
  selector: 'app-telecom-industry',
  templateUrl: './telecom-industry.component.html',
  styleUrl: './telecom-industry.component.scss',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, FixedCallComponent],
})
export class TelecomIndustryComponent {
  constructor() {}
}
